'kiwi public';

import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import xhr from 'xhr';
import _ from 'lodash';
import JSON5 from 'json5';
import Logger from './Logger';
var log = Logger.namespace('ConfigLoader');
var ConfigLoader = /*#__PURE__*/function () {
  function ConfigLoader() {
    _classCallCheck(this, ConfigLoader);
    this.config = Object.create(null);
    this.valReplacements = Object.create(null);
  }
  return _createClass(ConfigLoader, [{
    key: "addValueReplacement",
    value: function addValueReplacement(key, value) {
      this.valReplacements[key] = value;
      return this;
    }
  }, {
    key: "loadFromUrl",
    value: function loadFromUrl(configUrl) {
      var _this = this;
      return new _Promise(function (resolve, reject) {
        xhr({
          url: configUrl
        }, function (err, response) {
          if (err) {
            reject();
            return;
          }
          var configObj = null;
          try {
            configObj = JSON5.parse(response.body);
          } catch (parseErr) {
            log.error('Config ' + parseErr.message);
            var errMsg = 'Config file error: ' + parseErr.message.replace('JSON5: ', '');
            // Convert "at 22:16" to "at line 22, position 16"
            /* eslint-disable arrow-body-style */
            errMsg = errMsg.replace(/at (\d+):(\d+)/g, function (m, m1, m2) {
              var _context;
              return _concatInstanceProperty(_context = "line ".concat(m1, ", position ")).call(_context, m2);
            });
            reject(errMsg);
            return;
          }
          _this.setConfig(configObj);
          resolve(_this.config);
        });
      });
    }
  }, {
    key: "loadFromObj",
    value: function loadFromObj(configObj) {
      var _this2 = this;
      return new _Promise(function (resolve, reject) {
        _this2.setConfig(configObj);
        resolve(_this2.config);
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig(confObj) {
      var _this3 = this;
      var _walkObject = function walkObject(obj, target) {
        _.each(obj, function (_val, key) {
          var val = _val;
          if (typeof val === 'string') {
            val = _this3.insertReplacements(val);
            target[key] = val;
          } else if (_typeof(val) === 'object') {
            target[key] = _.isArray(val) ? [] : {};
            _walkObject(val, target[key]);
          } else {
            target[key] = val;
          }
        });
      };
      this.config = Object.create(null);
      _walkObject(confObj, this.config);
    }
  }, {
    key: "insertReplacements",
    value: function insertReplacements(input) {
      var out = input;
      var keys = _Object$keys(this.valReplacements);
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (input === '{{' + k + '}}') {
          // If we have an exact match, return the exact replacement value we have as
          // it may not be a string
          return this.valReplacements[k];
        }
        out = out.replace('{{' + k + '}}', this.valReplacements[k]);
      }
      return out;
    }
  }]);
}();
export { ConfigLoader as default };
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ConfigLoader"]
window._kiwi_exports.libs.ConfigLoader = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
